import { render, staticRenderFns } from "./PhoneFunctionButton.vue?vue&type=template&id=7249297b&scoped=true&lang=pug&"
import script from "./PhoneFunctionButton.vue?vue&type=script&lang=js&"
export * from "./PhoneFunctionButton.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFunctionButton.vue?vue&type=style&index=0&id=7249297b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249297b",
  null
  
)

export default component.exports